import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from '@/router';
import { mapActions } from 'vuex';

export default {
    name: 'newPromotionDermo',

    data(){
        return {
            promotionType: 3, // Dermo type is 3
            promotionWithSamples: 1,
        }
    },

    components: {
        BaseLayout,
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Send to server new created promotion
         */
        submitCreatePromotion: function () {
            const params = new FormData();
            params.append('type', this.promotionType);
            params.append('promotion_with_samples', Number(this.promotionWithSamples) === 1 ? 1 : 0);
            params.append('promotion_with_gifts', Number(this.promotionWithSamples) === 1 ? 0 : 1);

            api.post(`/api/promotions_start/${this.$route.params.id}`, params)
                .then(() => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },
}